import { useEffect } from "react";
import { useSelector } from "react-redux";

import { type IAppState } from "../../redux/reducer.js";
import { getDefaultBrowserTitle } from "../dom.js";

// using "disabled" flag to not break the first rule of hooks: they cannot be conditionally called
const useDocumentTitle = (title: string, disabled = false) => {
  const config = useSelector((state: IAppState) => state.config);

  useEffect(() => {
    if (config?.configuration && !disabled) {
      if (typeof title === "string") {
        document.title = `${title} - ${getDefaultBrowserTitle(config.configuration)}`;
      } else {
        document.title = getDefaultBrowserTitle(config.configuration);
      }
    }
  }, [config?.configuration, disabled, title]);
};

export { useDocumentTitle };
